<template>
    <div id="playerContainer" @click="closePopups">
        <div id="player">
            <div id="front">
                <img v-if="store.publicPlayerStatus == 'playing'" id="mute" @click="mute"
                    src="/static/icons/pause.svg" />
                <img v-else-if="store.publicPlayerStatus == 'loading'" id="spinner"
                    src="/static/icons/spinner-small.svg" alt="" />
                <img v-else id="play" @click="unmute" src="/static/icons/play-stream.svg" />
                <audio ref="audio" src="" preload="none" @ended="setSource"></audio>
                <div v-if="!store.live && $mq != 'sm'" id="time" v-html="remaining"></div>
                <span v-if="store.live && $mq != 'sm'" id="live">Live Now</span>
                <router-link :to="{ name: 'detail', params: { id: getPK } }" id="title">{{ getTitle }}</router-link>
            </div>

            <!-- <img v-if="$mq=='sm'" @click="store.mobileMenu = true" src="/static/Burger.svg" id="burger"/>  -->
            <div v-if="$mq != 'sm' && store.live && this.store.liveTrack" id="liveInfo">
                <span>
                    {{ store.liveTrack.city }}
                </span>
                <span id="liveInfoTime" v-html="time"> </span>
                <!--
            <a href="https://tlk.io/montezpressradio" target="_blank">
            <img id="chatImage" src="static/icons/chat.svg" alt="">
            </a>
            -->
            </div>
        </div>

        <!-- <div v-if="$mq == 'sm' && store.live" id="subPlayer"> -->
        <!--     <div> -->
        <!--         <div> -->
        <!--             <span> -->
        <!--                 {{ store.livePlace }} -->
        <!--             </span> -->
        <!--             <span id="liveInfoMobileTime" v-html="time"></span> -->
        <!--             <span id="live">LIVE NOW</span> -->
        <!--         </div> -->
        <!--     </div> -->
        <!-- </div> -->
    </div>
</template>

<script>
import { store } from "../store";
import Duration from "luxon/src/duration.js";
import DateTime from "luxon/src/datetime.js";

export default {
    name: "Player",
    data() {
        return {
            store: store,
            remaining: "",
            blink: true,
            timeBlink: true,

            time: null,
        };
    },
    watch: {
        "store.live"(newVal, oldVal) {
            if (newVal != oldVal) {
                if (this.store.playerCanPopup) {
                    //if (newVal == true){
                    //alert('We are now switching to live radio.');
                    //this.store.publicPlayerStatus = 'muted'
                    //} else {
                    //alert('We are now switching to archived radio.');
                    //this.store.publicPlayerStatus = 'muted'
                    //}
                    this.store.publicPlayerStatus = "muted";
                    this.store.showSwitchPopup = true;
                }
            }
        },
        "store.publicPlayerStatus"(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == "muted") {
                    let audio = this.$refs.audio;
                    audio.muted = true;
                }
            }
        },
    },
    computed: {
        getTitle() {
            if (this.store.live) {
                //if (this.store.liveList.length){
                //return this.store.liveList[0].artist + ': ' + this.store.liveList[0].title
                //}
                if (this.store.liveTrack) {
                    if (
                        this.store.liveTrack.artist &&
                        this.store.liveTrack.title
                    ) {
                        return (
                            this.store.liveTrack.artist +
                            ": " +
                            this.store.liveTrack.title
                        );
                    } else if (this.store.liveTrack.artist) {
                        return this.store.liveTrack.artist;
                    } else if (this.store.liveTrack.title) {
                        return this.store.liveTrack.title;
                    }
                }
            } else if (this.store.playlist.length > 0) {
                if (
                    this.store.playingItem.artist &&
                    this.store.playingItem.title
                ) {
                    return (
                        this.store.playingItem.artist +
                        ": " +
                        this.store.playingItem.title
                    );
                } else if (this.store.playingItem.artist) {
                    return this.store.playingItem.artist;
                } else if (this.store.playingItem.title) {
                    return this.store.playingItem.title;
                }
            }
        },
        getPK() {
            if (this.store.live) {
                if (this.store.liveTrack) {
                    return this.store.liveTrack.pk;
                }
            } else if (this.store.playlist.length > 0) {
                return this.store.playingItem.pk;
            }
        },
    },
    methods: {
        closePopups: function () {
            this.store.showAddPopup = false;
            this.store.showSubWarnPopup = false;
            this.store.showSubExpiredPopup = false;
            this.store.showSwitchPopup = false;
            this.store.showSupportPopup = false;
        },
        formatTime: function () {
            if (this.store.live && this.store.liveTrack) {
                //if (this.timeBlink){
                this.time =
                    DateTime.utc()
                        .setZone(this.store.liveTrack.timezone)
                        .setLocale("en-US")
                        .toFormat("hh:mm") +
                    "&thinsp;" +
                    DateTime.utc()
                        .setZone(this.store.liveTrack.timezone)
                        .setLocale("en-US")
                        .toFormat("a");
                //} else {
                //this.time =  DateTime.utc().plus({hours: this.store.liveTimezone}).setLocale('en-US').toFormat("hh'<span class=\"white\">:</span>'mm") + '&thinsp;' + DateTime.utc().plus({hours: this.store.liveTimezone}).setLocale('en-US').toFormat("a")
                //}
                //this.timeBlink = !this.timeBlink;
            }
        },
        formatDuration: function () {
            if (this.store.playlist.length > 0) {
                var iso = this.store.playingItem.last_played;
                var start = DateTime.fromISO(iso, { zone: "utc" });
                var end = start.plus({
                    seconds: this.store.playingItem.duration,
                });
                var remain = end.diff(DateTime.utc()).toObject();
                if (remain.milliseconds <= 0) {
                    remain.milliseconds = 0;
                }
                //if (this.blink){
                let duration = Duration.fromObject(remain);
                this.remaining = duration.toFormat("hh:mm:ss");
                //let remainingInSeconds = duration.as('seconds').toFixed()
                //if (remainingInSeconds < 1){
                //this.store.playingItem = this.store.playlist[this.store.playlist.indexOf(this.store.playingItem) + 1];
                //}

                //} else {
                //this.remaining = Duration.fromObject(remain).toFormat("hh'<span class=\"white\">:</span>'mm'<span class=\"white\">:</span>'ss")
                //}
                //this.blink = !this.blink;
            }
        },

        setSource() {
            let audio = this.$refs.audio;
            if (
                this.store.allowJingle &&
                !this.store.valid &&
                !this.store.live
            ) {
                audio.src =
                    this.store.jingles[
                        Math.floor(Math.random() * this.store.jingles.length)
                    ].audio;
                this.store.allowJingle = false;
                //sessionStorage.setItem('jinglePlayed', 'true');
            } else {
                if (this.store.live) {
                    audio.src =
                        "https://stream.montezpress.com/icecast/liveradio.mp3?ts=" +
                        new Date().getTime();
                } else {
                    //audio.src = 'https://stream.montezpress.com/icecast/radio.mp3?ts=' + new Date().getTime()
                    audio.src =
                        "http://localhost:8888/default?ts=" +
                        new Date().getTime();
                }
            }
            this.play();
        },
        play() {
            let audio = this.$refs.audio;
            let promise = audio.play();
            if (promise) {
                promise.then(() => {
                    //this.endmeasure = new Date();
                    //let timeSpent = this.endmeasure - this.startmeasure;
                    //this.playing = true;
                    //this.loading = false;
                    this.store.publicPlayerStatus = "playing";

                    //window._paq.push(['trackEvent', 'PlayerControl', 'Press Play', 'Audio Start', timeSpent]);
                });
            }
        },
        unmute: function () {
            let audio = this.$refs.audio;
            audio.muted = false;
            this.store.publicPlayerStatus = "loading";
            this.store.privatePlayerStatus = "paused";
            this.store.privatePlayerVisible = false;
            this.store.clickedPlay += 1;
            if (this.store.clickedPlay > 4) {
                this.store.allowJingle = true;
                this.store.clickedPlay = 0;
            }
            this.setSource();
        },
        mute: function () {
            //let audio = this.$refs.audio;
            //audio.muted = true;
            this.store.publicPlayerStatus = "muted";
        },
    },
    mounted() {
        let myself = this;
        setTimeout(function () {
            myself.store.publicPlayerStatus = "muted";
        }, 2000);
    },
    created() {
        this.formatDuration();
        setInterval(this.formatDuration, 1000);
        this.formatTime();
        setInterval(this.formatTime, 1000);
    },
    destroyed() {
        clearInterval(this.formatDuration);
        clearInterval(this.formatTime);
    },
};
</script>

<style scoped>
#playerContainer {
    box-sizing: border-box;
    background-color: white;
    width: 100%;
}

#player {
    padding: 0.7rem 1rem 0.8rem;
    border-bottom: 1px solid black;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100vw;
    box-sizing: border-box;
}

#subPlayer {
    padding: 1rem;
    border-bottom: 1px solid black;
    width: 100%;
    box-sizing: border-box;
}

#subPlayer>div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

#subPlayer span {
    margin-right: 1rem;
}

#front>* {
    margin-right: 1rem;
}

#front {
    display: flex;
    flex-direction: row;
    min-width: 0;
}

#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
    font-family: "Montez Small";
    font-size: 1rem;
    white-space: nowrap;
    margin-top: 0.25rem;
}

#live {
    font-family: "Montez Small";
    font-size: 1rem;
    margin-top: 0.25rem;
    animation: blink-animation 2s steps(2, start) infinite;
    -webkit-animation: blink-animation 2s steps(2, start) infinite;
    white-space: nowrap;
}

@media only screen and (min-width: 738px) {
    #time {
        font-family: "Montez Large";
        font-size: inherit;
        margin-top: 0;
    }

    #live {
        font-family: "Montez Large";
        font-size: inherit;
        margin-top: 0;
    }
}

@keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

@-webkit-keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

#title {
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

#play,
#mute {
    width: 1.6rem;
    height: 1.333rem;
    margin-top: 0.15rem;
}

#burger {
    width: 1.9rem;
    height: 1rem;
    margin-top: 0.3rem;
}

#play,
#mute {
    cursor: pointer;
}

#liveInfo {
    white-space: nowrap;
}

#liveInfo>* {
    margin-left: 1rem;
}

#liveInfo>a {
    margin-top: -5px;
}

#liveInfoTime,
#liveInfoMobileTime {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
    margin-right: 1rem;
}

#liveInfoTime {
    margin-right: 0;
}

#chatImage {
    height: 1.333rem;
}

>>>.white {
    color: white;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

#spinner {
    width: 1.6rem;
    animation: spin 1s linear infinite;
}
</style>
